import { generateSetChild, generateUpdateArrayChild, generateAddArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { dayjs, dayjsLocal } from "@/helpers/dayjs"

export default {
	namespaced: true,
	state: {
		zip: null,
		deliveryDates: [],
		deliveryDate: null,
		timeSlot: null,
	},
	actions: {
		async getDeliveryDates({state, commit, getters}, { zip }) {
			let result
			try {
				commit('setZip', { item: zip });

				result = await service.planzerDeliveryDates({ zip })

				const deliveryDates = (result.deliveryDates || []).map(date => {
					return {
						date: dayjs(date.deliveryDate).format('L'),
						timeSlots: date.timeSlots.map(timeSlot => {
							return {
								from: dayjs(`${date.deliveryDate} ${timeSlot.from}`).format('LT'),
								to: dayjs(`${date.deliveryDate} ${timeSlot.to}`).format('LT'),
							};
						})
					};
				});

				commit('setDeliveryDates', { item: deliveryDates })
				commit('setDeliveryDate', { item: getters.planzerDeliveryDates[0] || null});
				commit('setTimeSlot', { item: getters.planzerTimeSlots[0] || null});
			} catch(err) {
				result = null
			}
			return result
		},
		async setDeliveryDate({state, commit}, { date }) {
			commit('setDeliveryDate', { item: date });
		},
		async setTimeSlot({state, commit}, { timeSlot }) {
			commit('setTimeSlot', { item: timeSlot });
		},
	},
	getters: {
		planzerZip(state) {
			return state.zip;
		},
		planzerDeliveryDates(state) {
			return state.deliveryDates.map(date => date.date);
		},
		planzerDeliveryDateMin(state, getters) {
			return [...getters.planzerDeliveryDates].shift();
		},
		planzerDeliveryDateMax(state, getters) {
			return [...getters.planzerDeliveryDates].pop();
		},
		planzerDeliveryDate(state) {
			return state.deliveryDate;
		},
		planzerTimeSlots(state) {
			return (state.deliveryDates.find(date => date.date == state.deliveryDate)?.timeSlots || []).map(slot => {
				return `${slot.from} - ${slot.to}`;
			});
		},
		planzerTimeSlot(state) {
			return state.timeSlot;
		},
	},
	mutations: {
		setZip: generateSetChild("zip"),
		setDeliveryDates: generateSetChild("deliveryDates"),
		setDeliveryDate: generateSetChild("deliveryDate"),
		setTimeSlot: generateSetChild("timeSlot"),
	}
}
